import TtamPlacementTypeTiktokItem from './tiktok-item/index.vue';
import TtamPlacementTypeFlowTypeOptions from './flow-type-options/index.vue';
import TtamPlacementTypeInventoryflowList from './inventoryflow-list/index.vue';
import TtamPlacementTypeTips from './tips/index.vue';
import TtamPlacementTypeLabel from './label/index.vue';
import TtamPlacementTypeLabelHint from './label-hint/index.vue';
import TtamPlacementTypeVsaAutoItem from './vsa-auto-placement/index.vue';
import * as hooks from './hooks';

export default {
  TtamPlacementTypeInventoryflowList,
  TtamPlacementTypeTiktokItem,
  TtamPlacementTypeFlowTypeOptions,
  TtamPlacementTypeTips,
  TtamPlacementTypeLabel,
  TtamPlacementTypeLabelHint,
  TtamPlacementTypeVsaAutoItem,
  ...hooks,
};
